import { render, staticRenderFns } from "./NflNews.vue?vue&type=template&id=06f53cdc&scoped=true"
import script from "./NflNews.vue?vue&type=script&lang=js"
export * from "./NflNews.vue?vue&type=script&lang=js"
import style0 from "./NflNews.vue?vue&type=style&index=0&id=06f53cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f53cdc",
  null
  
)

export default component.exports